<template>
  <div class="property-pane">
    <h3 class="property-title" v-if="property.label">{{property.label}}</h3>
    <div class="attributes-wrapper" v-if="property.attributes">
      <div class="attribute-pane" v-for="(attribute, attrIndex) in property.attributes" :key="attrIndex" v-if="attribute.value">
        <div class="attribute-label">{{attribute.label}}</div>
        <div class="attribute-value" v-if="isUrl(attribute.value)"><a :href="attribute.value" target="_blank">{{attribute.value}}</a></div>
        <div class="attribute-value" v-else>{{attribute.value}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { isUrl } from 'mixins/utilities'

  export default {
    name: 'property-pane',
    props: ['property'],
    methods: {
      isUrl,
    },
  }
</script>

<style lang="scss" scoped>
  .property-title {
    font-family: $barlow;

    @include respond-to('desktop') {
      line-height: rem-calc(30);
    }
    margin-bottom: rem-calc(16);
  }
  .attribute-label {
    font-weight: bold;
    font-family: $barlow;
    color: $cadet-blue;
    text-transform: uppercase;
    margin-bottom: rem-calc(4);
    @include respond-to('desktop') {
      font-size: rem-calc(18);
      line-height: rem-calc(21);
    }
    @include respond-to('mobile') {
      font-size: rem-calc(16);
      line-height: rem-calc(19);
    }
  }
  .attribute-value {
    margin-bottom: rem-calc(20);
    @include respond-to('desktop') {
      font-size: rem-calc(18);
      line-height: rem-calc(24);
    }
    @include respond-to('mobile') {
      font-size: rem-calc(18);
      line-height: rem-calc(21);
    }
    a {
      color: $white;
      text-decoration: none;
      border-bottom: rem-calc(1) solid $rose;
    }
  }
</style>



// WEBPACK FOOTER //
// PropertyPane.vue?3146e2c6